export const PostApplication = {
    REVIEW:'Review Information',
    PRICING:'Pricing',
    DOCUMENTS:'Documents',
    COMMENT:'Comments',
    HISTORY:'History'
};

export const SourceType = {
    SALES_QUEUE:'sales-queue',
    SALES_SUPPORT:'sales-support'
}

export const TAB_SYSTEM_CONFIG = Object.freeze({
    enabled: true,
    defaultRoute: '/cli/credit-app/portal-dashboard',
    defaultLabel: 'Credit App',
    maxTabs: 10,
    enforceMaxTabs: true,
    showUnsavedChangesDialog: true,
});

export const LEFTNAV_FEATURE_CONFIG = Object.freeze({
    enabled: true,
    useNewHeaderNavigation: true,
});

export const USE_NEW_HEADER_LEFTNAV = LEFTNAV_FEATURE_CONFIG.useNewHeaderNavigation;

// Micro-apps can dispatch this event with `{ detail: { locked: true } }` while a modal/popup is open.
export const SHELL_NAVIGATION_LOCK_EVENT = 'shell:navigation-lock';